module.exports = parcelRequire.resolve("b8Bh1");